import { ReactNode } from 'react';
// import { EpHelper } from '../../../EpHelper';
import styles from './EpStepContent.module.scss';

interface IEpStepContentLabelProps {
  children: ReactNode;
  helpIconText?: string;
  label: string;
  required?: boolean;
  visible?: boolean;
}

export const EpStepContentLabel = ({
  children,
  // helpIconText,
  label,
  visible = true,
}: IEpStepContentLabelProps) => {
  if (!visible) return null;

  return (
    <div className={styles['label']}>
      <div className={styles['label__head']}>
        <p className={styles['label__txt']}>{label}</p>
        {/** @TODO - Rever o EpHelper, aparecendo de forma aleatória na tela e o popover não sendo mostrado */}
        {/* {helpIconText && (
          <EpHelper
            helperId='helpr-step-content'
            popoverId='popover-step-content'
            popoverHostId='popover-step-content'
            popoverText={helpIconText} />
        )} */}
      </div>
      {children}
      {/* {required && <p className={styles['label__txt--required']}>{t(translations['global'], '* Required Fied')}</p>} */}
    </div>
  );
};
